import cn from 'classnames';
import React, {FC, KeyboardEvent, ReactNode, useState} from 'react';

import TermsOfUseDescription from '../../containers/TNC/TermsOfUseDescription/TermsOfUseDescription';
import domService from '../../services/domService';
import ImgArrowIcon from '../Icons/IconExpansionPanelArrow';

interface IProps {
    title: string;
    innerText: string;
    children: ReactNode;
    index: number;
}

const ExpansionPanel: FC<IProps> = ({title, innerText, children, index}) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const onKeyPress = (e: KeyboardEvent) => domService.handleBtnKeyPress(e, onExpansionPanelClick);

    const onExpansionPanelClick = () => {
        setIsExpanded(!isExpanded);
    };

    const after =
        'after:content-[""] after:absolute after:h-px after:w-screen after:bg-alto-second after:bottom-0 after:right-1/2 after:translate-x-1/2 md:after:w-full ';

    const arrowClassName = cn('w-3 min-w-[12px] ease-in-out duration-200', {'rotate-180': isExpanded});

    return (
        <div className={cn('md:min-h-18 relative w-full cursor-pointer select-none', after)}>
            <div className={'flex items-center justify-between'}>
                <div
                    className={'flex w-full items-center'}
                    onClick={onExpansionPanelClick}
                    aria-expanded={isExpanded}
                    onKeyPress={onKeyPress}
                    aria-label={title}
                    tabIndex={0}
                    role='button'
                >
                    <ImgArrowIcon className={arrowClassName} onClick={onExpansionPanelClick} />
                    <span className='w-full px-4 py-6 text-start' id={`${index}`}>
                        {title}
                    </span>
                </div>
                {children}
            </div>
            {isExpanded && innerText && <TermsOfUseDescription innerHtml={innerText} className='pb-6 text-start' />}
        </div>
    );
};

export default ExpansionPanel;
